import { makeStyles } from '@mui/styles';

export const useSearchContentStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  header: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '8px',
    padding: '20px 16px 8px 20px'
  },
  title: {
    fontWeight: 700
  },
  subtitle: {
    flex: 1,
    color: theme.palette.text.secondary
  },
  closeButton: {
    alignSelf: 'flex-start'
  },
  inputArea: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 16px 4px 16px'
  },
  input: {
    flex: 1
  },
  searchButton: {
    flexShrink: 0
  },
  checkbox: {
    padding: '0 16px'
  },
  results: {
    flex: 1,
    overflowY: 'auto',
    padding: '8px 8px 24px 8px'
  },
  statusArea: {
    display: 'flex',
    justifyContent: 'center',
    padding: '32px 16px'
  },
  resultsFor: {
    padding: '4px 12px 8px 12px',
    color: theme.palette.text.secondary
  },
  message: {
    padding: '24px 20px',
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  error: {
    padding: '24px 20px',
    color: theme.palette.error.main
  }
}));
